import { BuiltinInterface } from '../BuiltinInterface';
import { BuiltinValueObject } from '../BuiltinValueObject';
class NumberInterface extends BuiltinInterface {
}
class NumberValue extends BuiltinValueObject {
    constructor() {
        super(...arguments);
        this.type = 'NumberConstructor';
    }
}
class NumberConstructorInterface extends BuiltinInterface {
}
export const add = (builtins) => {
    builtins.addInterface('Number', new NumberInterface());
    builtins.addValue('Number', new NumberValue());
    builtins.addInterface('NumberConstructor', new NumberConstructorInterface());
};

//# sourceMappingURL=index.js.map
